(() => {
  const KEY = 'bdb:wishlist:v1';
  const COOKIE_KEY = 'bdb_wishlist_v1';
  const readCookie = () => {
    try {
      const value = document.cookie.split('; ').find(row => row.startsWith(`${COOKIE_KEY}=`));
      return value ? JSON.parse(decodeURIComponent(value.split('=').slice(1).join('='))) : null;
    } catch (_) { return null; }
  };
  const read = () => {
    const cookieItems = readCookie();
    if (Array.isArray(cookieItems)) return cookieItems;
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; }
  };
  const write = items => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) {}
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(items))}; path=/; max-age=31536000; SameSite=Lax`;
    window.dispatchEvent(new CustomEvent('bdb:wishlist-change'));
  };
  const has = handle => read().some(item => item.handle === handle);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  function syncButtons() {
    document.querySelectorAll('[data-bdb-wishlist-toggle]').forEach(button => {
      const active = has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[aria-hidden="true"]').textContent = active ? '♥' : '♡';
      const label = button.querySelector('[data-bdb-wishlist-label]');
      if (label) label.textContent = active ? 'Bewaard op verlanglijst' : 'Bewaar op verlanglijst';
    });
  }

  function toggle(button) {
    const handle = button.dataset.productHandle;
    let items = read();
    if (items.some(item => item.handle === handle)) items = items.filter(item => item.handle !== handle);
    else items.unshift({handle,title:button.dataset.productTitle,url:button.dataset.productUrl,image:button.dataset.productImage,price:button.dataset.productPrice,variantId:button.dataset.variantId});
    write(items);
  }

  function bindButtons() {
    document.querySelectorAll('[data-bdb-wishlist-toggle]').forEach(button => {
      if (button.dataset.bdbWishlistBound === 'true') return;
      button.dataset.bdbWishlistBound = 'true';
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggle(button);
      });
    });
  }

  function renderPage() {
    const page = document.querySelector('[data-bdb-wishlist-page]');
    if (!page) return;
    const items = read();
    const grid = page.querySelector('[data-bdb-wishlist-grid]');
    const empty = page.querySelector('[data-bdb-wishlist-empty]');
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    grid.innerHTML = items.map(item => `<article class="bdb-wishlist-card" data-wishlist-handle="${escapeHtml(item.handle)}"><a class="bdb-wishlist-card__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy"></a><div class="bdb-wishlist-card__body"><h2><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h2><p class="bdb-wishlist-card__price">${escapeHtml(item.price)}</p><div class="bdb-wishlist-card__actions"><a href="${escapeHtml(item.url)}">Bekijk product</a><button type="button" data-bdb-wishlist-remove="${escapeHtml(item.handle)}">Verwijderen</button></div></div></article>`).join('');
  }

  document.addEventListener('click', event => {
    const toggleButton = event.target.closest('[data-bdb-wishlist-toggle]');
    if (toggleButton) return;
    const removeButton = event.target.closest('[data-bdb-wishlist-remove]');
    if (removeButton) write(read().filter(item => item.handle !== removeButton.dataset.bdbWishlistRemove));
  });
  window.addEventListener('bdb:wishlist-change', () => { syncButtons(); renderPage(); });
  function init() {
    const productButton = document.querySelector('.bdb-wishlist-button--product');
    const productInfo = document.querySelector('.product-info');
    if (productButton && productInfo) productInfo.appendChild(productButton);
    bindButtons();
    syncButtons();
    renderPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
